module.exports = __webpack_public_path__ + "img/ZuCool.4bb4713d.svg";